$( $ => {
  const blurbs = $( '.bs-div--features-blurb-wrapper' );
  if( blurbs.length === 0 ) return;
  blurbs.each( ( i, blurb ) => {
    const blurbLinkEl = $( blurb ).find( '.bs-blurb__trigger' );
    if ( blurbLinkEl.length > 0 ) { 
      const blurbLink = blurbLinkEl.attr( 'href' ),
        blurbTarget = blurbLinkEl.attr( 'target' );
      $( blurb )
        .prepend( `<a class="bs-features-blurb-wrapper-link" href="${blurbLink}" target="${blurbTarget}"></a>` );
    }
  } );
} );